export const HierarchicalItemName = 'hierarchicalItemComponent';
